import React from 'react';
import { useParams } from 'react-router-dom';
import ShopApplicationForm from '../ShopApplicationForm';

const ShopApplicationFormRequestChange = () => {
  const { shopId } = useParams<{ shopId: string }>();

  return <ShopApplicationForm mode="change" targetShopId={shopId} />;
};

export default ShopApplicationFormRequestChange;
